import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import Logger from "dce-logger/lib/logger/Logger";

import DceAjaxResponse from "dce-ajax/lib/ajax/DceAjaxResponse";
import AjaxForm from "../AjaxForm";
import EventsContainer from "../utils/EventsContainer";
import DceAjax from "../../../../dce-ajax/lib/ajax/DceAjax";
import DialogStack from "./DialogStack";

interface DialogProps {
    url?: string;
    documentTitle?: string;
    bindForm:boolean;
}

@Dce("Dialog")
export default class Dialog extends DceComponent<DialogProps> {

    private static EVENT_CLOSE = "close";

    protected logger = Logger.of("Dialog");

    private block: JQuery<HTMLElement>;

    protected target: JQuery<HTMLElement>;

    protected onPopStateAdded = false;

    protected onPopState: (e:PopStateEvent) => void;

    protected formsInitialized: DceHTMLElement[] = [];

    private _dialogIsNextStep = false;

    protected formSaved:boolean = false;

    private _formResponse:DceAjaxResponse = null;

    private events: EventsContainer<Dialog>;

    private prevDocumentTitle: string;

    constructor(elem: DceHTMLElement, props: DialogProps) {
        super(elem, props);
        this.block = $(elem);
        this.target = this.block.parent();
        this.events = new EventsContainer<Dialog>(this, elem);

        setTimeout(() => this.block.addClass('active'), 50);

        if(this.props.url){
            //window.history.pushState(null, "", this.props.url);

            this.prevDocumentTitle = document.title;
            if(this.props.documentTitle) {
                document.title = this.props.documentTitle;
            }

            this.onPopStateAdded = true;

            DialogStack.getInstance()
                .push(this.props.url, this.props.documentTitle, () => {
                    this.closingTransition()
                });


            // this.onPopState = e => {
            //     document.title = this.prevDocumentTitle;
            //     this.closingTransition();
            // };
            //
            // window.addEventListener('popstate', this.onPopState);
        }

    }


    public setForm(formSaved:boolean, formResponse:DceAjaxResponse){
        this.formSaved = formSaved;
        this._formResponse = formResponse;
    }

    public getFormBind():boolean{
        return this.props.bindForm;
    }

    public getFormSaved():boolean {
        return this.formSaved;
    }

    public getFormResponse(): DceAjaxResponse {
        return this._formResponse;
    }

    public addOnClose(callback: (a: Dialog, e: HTMLElement) => void){
        this.events.register(Dialog.EVENT_CLOSE, callback);
    }

    public closeAction(e:Event, element: HTMLElement){

        e.preventDefault();

        let link = element as HTMLElement;

        this.target.addClass('loading');

        DceAjax.getInstance()
            .get(link.getAttribute('href'))
            .then((resp: DceAjaxResponse) => {

                this.formSaved = true;
                this._formResponse = resp;
                this.close();

                this.target.removeClass('loading');
            });
    }

    public replaceContent(e:Event, element: HTMLElement){
        e.preventDefault();

        let link = element as HTMLElement;

        this.target.addClass('loading');

        DceAjax.getInstance()
            .get(link.getAttribute('href'))
            .then((resp: DceAjaxResponse) => {
                if(resp.hasResponse()){
                    let newElem = $(resp.response);
                    this.elem.innerHTML = newElem.html();
                }

                this.formSaved = true;
                this._formResponse = resp;

                this.target.removeClass('loading');
            });
    }

    public onSubComponentInit(component: string, elem: DceHTMLElement){

        this.logger.debug("Subcomp init", component, elem);

        if(this.props.bindForm){

            if(component == 'AjaxForm'){

                if(this.formsInitialized.indexOf(elem) === -1) {
                    this.formsInitialized.push(elem);

                    if (elem.ext.hasComponent('AjaxForm')) {

                        let ajaxForm = elem.ext.getComponent('AjaxForm') as AjaxForm;

                        if(ajaxForm.isDialogForm()) {

                            this.logger.debug("Form dialog: ", ajaxForm, elem);

                            ajaxForm.addOnSave((a, e) => {

                                this.logger.debug("Close By Form", this.formSaved, this._formResponse);

                                this._formResponse = a.formResponse;
                                this.formSaved = a.formSaved;

                                if (!this._formResponse.hasResponse()) {
                                    this.close();
                                }

                            });
                        }

                    }

                }
            }
        }

    }


    private closingTransition(){
        // if(this.onPopStateAdded) {
        //     window.removeEventListener('popstate', this.onPopState)
        // }
        this.block.removeClass('active');

        this.logger.debug("EXECUTING CLOSE EVENTS ON DIALOG!");
        this.events.call(Dialog.EVENT_CLOSE);

        setTimeout(() => this.block.remove(), 300);
    }

    public close(e:Event = null){
        if(this.onPopStateAdded){
            window.history.back();
            return;
        }

        this.closingTransition();
    }

    public openNext(e:Event, element: HTMLElement){
        e.preventDefault();

        let link = e.target as HTMLElement;

        this.formSaved = true;
        this._formResponse = new DceAjaxResponse({
            actions: {
                nextDialog: element.getAttribute('href')
            }
        }, 200);

        this.close();
    }

    protected openDialog(html: string){
        let view = $(html);
        view.appendTo(this.target);
    }

    get dialogIsNextStep(): boolean {
        return this._dialogIsNextStep;
    }

    set dialogIsNextStep(value: boolean) {
        this._dialogIsNextStep = value;
    }

    defaultProps(): DialogProps {
        return {
            bindForm: true
        };
    }
}
